<form
  name="form"
  fxLayout="column"
  autocomplete="off"
  fusePerfectScrollbar
  [formGroup]="locationForm"
  class="field-dialog__content__scroll p-24"
>
  <div fxLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="start">
    <address fxFlex="100" [addressForm]="locationForm.get('address')" [isViewMode]="isViewMode"></address>
  </div>

  <div *ngIf="!isViewMode" fxLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="start">
    <p>
      {{ 'LOCATIONS.DIALOG.TABS.TAB_LOCATION.DESCRIPTION' | translate }}
    </p>
  </div>

  <div class="map" fxLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="start">
    <div class="map__container">
      <map-address [addressForm]="locationForm.get('address')" [isViewMode]="isViewMode"></map-address>
    </div>
  </div>
  <p>
    {{ 'LOCATIONS.DIALOG.TABS.TAB_LOCATION.LATITUDE' | translate }}:
    {{ locationForm?.value?.address?.coords?.latitude }}
    {{ 'LOCATIONS.DIALOG.TABS.TAB_LOCATION.LONGITUDE' | translate }}:
    {{ locationForm?.value?.address?.coords?.longitude }}
    <a
      href="http://www.google.com/maps?q={{ locationForm?.value?.address?.coords?.latitude }},{{
        locationForm?.value?.address?.coords?.longitude
      }}"
      target="_blank"
    >
      {{ 'LOCATIONS.DIALOG.TABS.TAB_LOCATION.SEE_ON_GOOGLE_MAPS' | translate }}
    </a>
  </p>
</form>
